import { render, staticRenderFns } from "./displayer.vue?vue&type=template&id=a0132f1e&scoped=true&"
import script from "./displayer.vue?vue&type=script&lang=js&"
export * from "./displayer.vue?vue&type=script&lang=js&"
import style0 from "./displayer.vue?vue&type=style&index=0&id=a0132f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0132f1e",
  null
  
)

export default component.exports